import {
  closeModalSafely as closeModalSafelyBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (...args) =>
  handleSubmitBase(
    'printers/rego',
    'editPrinterSuccess',
    'editPrinterError',
    'createPrinterSuccess',
    'createPrinterError',
    ...args,
  );
